import { render } from "./Offerings.vue?vue&type=template&id=e2a3c0c2"
import script from "./Offerings.vue?vue&type=script&lang=js"
export * from "./Offerings.vue?vue&type=script&lang=js"
script.render = render

export default script